import { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import Tab from "../../common/Tab";
import BreadcrumbSearch from "../../common/BreadcrumbSearch";
import Analytics from "./Analytics";
import Card from "./Card";
import List from "./List";
import Profile from "./Profile";
import NotFound from "../../common/ErrorPage/NotFound";

const Candidate = (props) => {
  const [width, setWidth] = useState(window.innerWidth);

  const districtNames = {};
  const parties = {};
  const candidates = props.candidates;

  props.provinces.forEach((p) => {
    p.districts.forEach((d) => {
      districtNames[d.id] = { np: d.name_np, en: d.name_en };
    });
  });

  props.parties.forEach((p) => {
    parties[p.code] = { np: p.name_np, en: p.name_en };
  });

  const handleWindowSizeChange = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const isMobile = width <= 768;

  return (
    <>
      {/* <Tab tab={props.tab} handleTabChange={props.handleTabChange} /> */}
      {/* <BreadcrumbSearch showSearch={false} candidates={candidates} /> */}
      <Routes>
        <Route path="/" element={ <List tab={props.tab} fetched={props.fetched} data={candidates} parties={parties} districtNames={districtNames} />}></Route>
        <Route path=":party" element={ <List tab={props.tab} fetched={props.fetched} data={candidates} parties={parties} districtNames={districtNames} />}></Route>
        <Route path="analytics/" element={<Analytics fetched={props.fetched} data={candidates} parties={parties} />}></Route>
        <Route path=":party/analytics" element={<Analytics fetched={props.fetched} data={candidates} parties={parties} />}></Route>
        <Route path="profile/:cid" element={<Profile fetched={props.fetched} data={candidates} parties={parties} districtNames={districtNames} />}></Route>
        <Route path="*" element={<NotFound />}></Route>
      </Routes>
    </>
  );
};

export default Candidate;
